import API_INTERFACE_URI from "../constants/uri.constants";
import baseService from "./service";
import {globalHeaders} from "../utilities/http";

function getLgStatus(searchValue, searchType, dcCode, olpnPage = 0, olpnSize = 10) {
    let lgStatusParams = ``;

    if (searchType === 'shipmentId') {
        lgStatusParams = lgStatusParams.concat(`filters=shipmentId(${searchValue})`);
    } else {
        lgStatusParams = lgStatusParams.concat(`filters=loadingGroup(${searchValue})`);
    }

    if (dcCode) {
        lgStatusParams = lgStatusParams.concat(`&filters=destLocCode(${dcCode})`);
    }

    const safeSize = Number(olpnSize) || 10;
    const safePage = Number(olpnPage) || 0;
    lgStatusParams = lgStatusParams.concat(`&olpnPage=${safePage}&olpnSize=${safeSize}`);

    let url = API_INTERFACE_URI.LG_STATUS;
    if (lgStatusParams !== undefined) url = url + "?" + lgStatusParams;
    return baseService.get(url, globalHeaders);
}

export const LgStatusService = {
    getLgStatus
};
